import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/app';
import GlobalStyle from './global.styles';

window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (
        reason?.name === 'AbortError' &&
        /fetching process for the media resource was aborted|aborted by the user agent/i.test(reason.message || '')
    ) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}, true); // capture phase, so this runs before react-error-overlay's listener

ReactDOM.render(
    <React.StrictMode>
        <GlobalStyle />
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
